import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { FavoriteToggle } from '~src/favorites/components/favoriteToggle/FavoriteToggle';
import { CardTitle } from '~src/spacesPlatform/components/card/CardTitle';
import { CardViewStyles } from '~src/spacesPlatform/components/card/CardViewStyles';
import { CardPopoverWidget, ContentCard, getContentUrlForItem } from '~src/spacesPlatform/components/card/ContentCard';
import { ContentTooltipProps } from '~src/spacesPlatform/components/tooltip/TooltipHelper';

import { DataRoleTooltip } from '../tooltips/DataRoleTooltip';
import { DataRoleThumbnail } from './DataRoleThumbnail';

export class DataRoleCard extends ContentCard {

  public render() {
    const {
      content, hovered, selected, urls, allowDragAndDrop, addContentFavorite, removeContentFavorite
    } = this.props;
    return (
      <div className={CardViewStyles.Card}>
        <DataRoleThumbnail
          hovered={hovered}
          selected={selected}
          navigateUrl={getContentUrlForItem(content, urls)}
          owner={content.owner}
          urls={urls}
          allowDragAndDrop={allowDragAndDrop}
          aria-label={content.name}
        />
        <div className={CardViewStyles.ActionRow}>
          <CardTitle name={content.name} />
          <span>
            <CardPopoverWidget
              content={content}
              onTriggerClick={this.handleShowPopover}
              popoverContent={this.renderPopoverContent()}
              title={Messages.dataRoleTooltipTitle()}
            />
          </span>
          <span>
            <FavoriteToggle
              isTabbable={true}
              isFavorite={content.favorite}
              onAddFavorite={() => addContentFavorite({ ...content, contentType: 'dataRole' })}
              onRemoveFavorite={() => removeContentFavorite({ ...content, contentType: 'dataRole' })}
            />
          </span>
          { this.renderActionsMenu() }
        </div>
        <div className={CardViewStyles.CardDescription}>
          {this.getDescription()}
        </div>
      </div>
    );
  }

  protected getPopoverComponent(): React.ComponentType<ContentTooltipProps> {
    return DataRoleTooltip;
  }
}
